import clsx from "clsx";

import { PDPProduct } from "@/features/product/types";
import { useTranslations } from "next-intl";

import { useProductContext } from "@/features/product/ProductProvider";
import { useMemo } from "react";
import styles from "./index.module.css";

const VariantSelector = ({ product }: { product: PDPProduct }) => {
  const t = useTranslations();
  const { activeVariantId, setActiveVariant, activeVariant } =
    useProductContext();

  const sortedVariants = useMemo(() => {
    return !product?.variants
      ? undefined
      : [...product.variants].sort((a, b) => {
          const aSoldOut = a.soldOut ?? false;
          const bSoldOut = b.soldOut ?? false;

          if (aSoldOut === bSoldOut) return 0;
          return aSoldOut ? 1 : -1;
        });
  }, [product?.variants]);

  if (!sortedVariants) return null;

  return (
    <div>
      <span className={styles.colorLabel}>
        {t("product.colour")}{" "}
        <span className={styles.colorName}>{activeVariant?.variantName}</span>
      </span>
      <div className={styles.productVariants}>
        {sortedVariants?.map((variant, i) => {
          return (
            <button
              key={i}
              title={variant?.name}
              className={styles.button}
              onClick={() => {
                setActiveVariant(variant.itemId);
              }}
            >
              <div
                className={clsx(
                  variant.itemId === activeVariantId && styles.selected,
                  styles.swatch,
                )}
              >
                <div
                  style={{
                    backgroundColor: `${variant?.swatch?.hex}`,
                  }}
                />
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default VariantSelector;
